import { render, staticRenderFns } from "./OilCompanyList.vue?vue&type=template&id=31b9b020&scoped=true&"
import script from "./OilCompanyList.vue?vue&type=script&lang=ts&"
export * from "./OilCompanyList.vue?vue&type=script&lang=ts&"
import style0 from "./OilCompanyList.vue?vue&type=style&index=0&id=31b9b020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9b020",
  null
  
)

export default component.exports